module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_sp_over5000-b61c18f126c44c7f8d4eba5a558cab07.png";